export const driverAndSorterInvoiceStatus = ["new", "paid", "unpaid"];